import { ModalBody, ModalContent, ModalHeader } from "@heroui/react";
import type { BridgeTxFailed } from "../../state/types";
import { formatTimestamp } from "../../utils";
import { TxHashLink } from "../TxHashLink";
import { BridgeCard } from "../bridge/BridgeCard";
import { TransactionTypeChip } from "../bridge/TransactionTypeChip";

export function BridgeFailedTxDetails({
  txData,
}: {
  txData: BridgeTxFailed;
}) {
  const senderAddress =
    txData.state === "unclaimed"
      ? txData.bridgeType === "deposit"
        ? txData.bridgeFormData.l1AccountAddress
        : txData.bridgeFormData.l2AccountAddress.toString()
      : "0x";
  const recipientAddress =
    txData.state === "unclaimed"
      ? txData.bridgeType === "deposit"
        ? txData.bridgeFormData.l2AccountAddress.toString()
        : txData.bridgeFormData.l1AccountAddress
      : "0x";
  const tokenSymbol = txData.state === "unclaimed" ? txData.bridgeFormData.tokenSymbol : "";
  const displayAmount = txData.state === "unclaimed" ? txData.bridgeFormData.transferAmount : 0n;

  return (
    <ModalContent>
      <ModalHeader>Bridge details</ModalHeader>
      <ModalBody>
        <BridgeCard bridgeType={txData.bridgeType} displayAmount={Number(displayAmount)} tokenSymbol={tokenSymbol} />

        <div className="w-full space-y-3">
          <div className="flex items-center justify-between">
            <div className="font-semibold text-[#ADC0D0]">Status</div>
            <div className="font-semibold text-[#FF4D4D]">Failed</div>
          </div>
          <div className="flex items-center justify-between">
            <div className="font-semibold text-[#ADC0D0]">Transaction type</div>
            <TransactionTypeChip type="public" />
          </div>
          <div className="flex items-center justify-between">
            <div className="font-semibold text-[#ADC0D0]">Date & Time</div>
            <div className="font-semibold">{formatTimestamp(txData.timestamp)}</div>
          </div>
          <div className="flex items-center justify-between">
            <div className="font-semibold text-[#ADC0D0]">From</div>
            <div className="font-semibold">
              <TxHashLink txHash={senderAddress} source={txData.bridgeType === "deposit" ? "l1" : "l2"} />
            </div>
          </div>
          <div className="flex items-center justify-between">
            <div className="font-semibold text-[#ADC0D0]">To</div>
            <div className="font-semibold">
              <TxHashLink txHash={recipientAddress} source={txData.bridgeType === "deposit" ? "l2" : "l1"} />
            </div>
          </div>
        </div>

        <details className="w-full bg-[#3F6784] p-4 rounded-2xl space-y-3 text-sm">
          <summary className="font-semibold text-[#ADC0D0] cursor-pointer">Error message</summary>
          <div className="font-semibold text-[#FF4D4D] mt-2 overflow-auto max-h-48">{txData.errorMessage}</div>
        </details>
      </ModalBody>
    </ModalContent>
  );
}
